@if(tripType === 'pre'){
    @if(isMobileView()){
        <app-mobile-pre-trip-request [requestId]="requestId"></app-mobile-pre-trip-request>
    }
    @else {
        <app-pre-trip-request [requestId]="requestId"></app-pre-trip-request>
    }
}
@else {
    @if(isMobileView()){
        <app-mobile-post-trip-request [requestId]="requestId" [mode]="mode"></app-mobile-post-trip-request>
    }
    @else {
        <app-post-trip-request [requestId]="requestId" [mode]="mode"></app-post-trip-request>
    }
}

